import styled from 'styled-components';
import { MTextBlockBasicAlignment } from './MTextBlockBasic.types';

interface WrapperProps {
  alignment: MTextBlockBasicAlignment;
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  text-align: ${props => (props.alignment === MTextBlockBasicAlignment.Centered ? 'center' : 'start')};
  align-items: ${props => (props.alignment === MTextBlockBasicAlignment.Centered ? 'center' : 'flex-start')};
`;
